"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("mousetrap");

var msteams_ui_icons_react_1 = require("msteams-ui-icons-react");

var dropdown_1 = require("msteams-ui-styles-core/lib/components/dropdown");

var React = require("react");

var teams_context_1 = require("../teams-context");

var classes_1 = require("../utils/classes");

var uniqueId_1 = require("../utils/uniqueId");

var item_1 = require("./item");

var DropdownInternal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DropdownInternal, _React$Component);

  function DropdownInternal() {
    var _this;

    _classCallCheck(this, DropdownInternal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropdownInternal).apply(this, arguments));
    _this.state = {
      show: false,
      id: uniqueId_1.default('ts-dd-'),
      expandableRegionId: uniqueId_1.default('ts-dd-e-')
    };
    _this.mounted = false;
    _this.dropdown = null;
    _this.mousetrap = null;
    _this.mainButton = null;
    _this.itemButtons = [];

    _this.open = function () {
      if (_this.mounted) {
        _this.setState({
          show: true
        }, _this.focusNext);

        document.addEventListener('click', _this.close);
      }
    };

    _this.close = function () {
      if (_this.mounted) {
        document.removeEventListener('click', _this.close);

        _this.setState({
          show: false
        });
      }
    };

    _this.trapKeyboard = function () {
      if (_this.mousetrap) {
        _this.mousetrap.bind('shift+tab', _this.onTabUpKey);

        _this.mousetrap.bind('tab', _this.onTabDownKey);

        _this.mousetrap.bind('esc', _this.onEscKey);

        _this.mousetrap.bind('up', _this.onUpKey);

        _this.mousetrap.bind('down', _this.onDownKey);
      }
    };

    _this.untrapKeyboard = function () {
      if (_this.mousetrap) {
        _this.mousetrap.reset();
      }
    };

    _this.onUpKey = function (e) {
      e.preventDefault();

      if (!_this.state.show) {
        _this.setState({
          show: true
        }, _this.focusPrevious);
      } else {
        _this.focusPrevious();
      }
    };

    _this.onDownKey = function (e) {
      e.preventDefault();

      if (!_this.state.show) {
        _this.setState({
          show: true
        }, _this.focusNext);
      } else {
        _this.focusNext();
      }
    };

    _this.onTabUpKey = function (e) {
      if (_this.state.show) {
        e.preventDefault();

        _this.focusPrevious();
      }
    };

    _this.onTabDownKey = function (e) {
      if (_this.state.show) {
        e.preventDefault();

        _this.focusNext();
      }
    };

    _this.onEscKey = function (e) {
      if (_this.state.show) {
        e.preventDefault();

        if (_this.mainButton) {
          _this.mainButton.focus();
        }

        _this.close();
      }
    };

    _this.currentIndex = function () {
      return _this.itemButtons.findIndex(function (elm) {
        return elm.hasFocus();
      });
    };

    _this.focusNext = function () {
      var current = _this.currentIndex();

      var next = current + 1 > _this.itemButtons.length - 1 ? 0 : current + 1;

      _this.itemButtons[next].focus();
    };

    _this.focusPrevious = function () {
      var current = _this.currentIndex();

      var next = current - 1 < 0 ? _this.itemButtons.length - 1 : current - 1;

      _this.itemButtons[next].focus();
    };

    return _this;
  }

  _createClass(DropdownInternal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.dropdown) {
        this.mousetrap = new Mousetrap(this.dropdown);
      }

      this.mounted = true;
      this.trapKeyboard();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.untrapKeyboard();
      this.close();
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var state = this.state;
      this.itemButtons = [];

      var _a = this.props,
          context = _a.context,
          className = _a.className,
          children = _a.children,
          menuRightAlign = _a.menuRightAlign,
          label = _a.label,
          mainButtonText = _a.mainButtonText,
          style = _a.style,
          items = _a.items,
          rest = __rest(_a, ["context", "className", "children", "menuRightAlign", "label", "mainButtonText", "style", "items"]);

      var themeClassNames = dropdown_1.dropdown(context);
      var itemContainerClass = [themeClassNames.itemContainer];

      if (menuRightAlign) {
        itemContainerClass.push(themeClassNames.itemContainerRight);
      }

      if (this.state.show) {
        itemContainerClass.push(themeClassNames.showItems);
      }

      return React.createElement("div", {
        ref: function ref(_ref) {
          return _this2.dropdown = _ref;
        },
        className: classes_1.default(themeClassNames.container, className),
        style: style
      }, label ? React.createElement("label", {
        className: themeClassNames.label,
        htmlFor: state.id
      }, label) : null, React.createElement("button", Object.assign({
        ref: function ref(_ref2) {
          return _this2.mainButton = _ref2;
        },
        role: "combobox",
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        },
        "aria-controls": this.state.expandableRegionId,
        "aria-expanded": this.state.show,
        className: themeClassNames.mainButton.container,
        onClick: this.open
      }, rest, {
        id: state.id
      }), mainButtonText ? React.createElement("span", {
        className: themeClassNames.mainButton.text
      }, mainButtonText) : null, React.createElement(msteams_ui_icons_react_1.MSTeamsIcon, {
        className: themeClassNames.mainButton.icon,
        iconType: msteams_ui_icons_react_1.MSTeamsIconType.ChevronDown,
        iconWeight: msteams_ui_icons_react_1.MSTeamsIconWeight.Light
      })), React.createElement("div", {
        id: this.state.expandableRegionId,
        role: "listbox",
        "aria-hidden": !this.state.show,
        style: {
          display: this.state.show ? undefined : 'none'
        },
        className: itemContainerClass.join(' ')
      }, items.map(function (item, idx) {
        return React.createElement(item_1.DropdownItem, {
          key: idx,
          role: "option",
          context: context,
          tabIndex: -1,
          text: item.text,
          render: item.render,
          onClick: item.onClick,
          ref: function ref(_ref3) {
            return _ref3 && _this2.itemButtons.push(_ref3);
          }
        }, item.text);
      })));
    }
  }]);

  return DropdownInternal;
}(React.Component);

exports.Dropdown = teams_context_1.connectTeamsComponent(DropdownInternal);